(function () {

  /* =======================================================
     PRODUCT LINKS

     All supplied tarot product URLs are mapped here,
     including Emperor + Magician for future animation use.
     ======================================================= */

  const tarotProductLinks = {

    sun:
      "https://www.custommetalbusinesscards.com/products/the-sun-metal-tarot-card",

    justice:
      "https://www.custommetalbusinesscards.com/products/justice-metal-tarot-card-anodized-keepsake",

    wheel:
      "https://www.custommetalbusinesscards.com/products/wheel-of-fortune-metal-tarot-card",

    emperor:
      "https://www.custommetalbusinesscards.com/products/the-emperor-metal-tarot-card",

    magician:
      "https://www.custommetalbusinesscards.com/products/the-magician-metal-tarot-card",

    priestess:
      "https://www.custommetalbusinesscards.com/products/high-priestess-metal-tarot-card",

    hierophant:
      "https://www.custommetalbusinesscards.com/products/the-hierophant-metal-tarot-card",

    chariot:
      "https://www.custommetalbusinesscards.com/products/the-chariot-metal-tarot-card",

    strength:
      "https://www.custommetalbusinesscards.com/products/strength-metal-tarot-card-anodized-keepsake"

  };


  const completeDeckUrl =
    "https://www.custommetalbusinesscards.com/products/complete-metal-tarot-card-deck";


  /* =======================================================
     ANIMATED CARD LIST
     ======================================================= */

  const tarotCards = [

    {
      key: "hierophant",

      name: "The Hierophant",

      src:
        "https://cdn.shopify.com/s/files/1/0631/5792/8098/files/hierophant.png",

      alt:
        "The Hierophant engraved metal tarot card",

      productUrl:
        tarotProductLinks.hierophant,

      headline:
        "The Hierophant — permanently engraved in metal.",

      support:
        "Tradition, guidance and spiritual authority translated into a durable anodized aluminum Major Arcana card."
    },


    {
      key: "priestess",

      name: "The High Priestess",

      src:
        "https://cdn.shopify.com/s/files/1/0631/5792/8098/files/priestess.png",

      alt:
        "The High Priestess engraved metal tarot card",

      productUrl:
        tarotProductLinks.priestess,

      headline:
        "The High Priestess — mystery made permanent.",

      support:
        "Classic High Priestess artwork engraved into anodized aluminum for readers, collectors, display and gifting."
    },


    {
      key: "justice",

      name: "Justice",

      src:
        "https://cdn.shopify.com/s/files/1/0631/5792/8098/files/justice.png",

      alt:
        "Justice engraved metal tarot card",

      productUrl:
        tarotProductLinks.justice,

      headline:
        "Justice — balance and truth engraved in metal.",

      support:
        "A permanent metal interpretation of the iconic Major Arcana design with crisp, high-contrast laser engraving."
    },


    {
      key: "strength",

      name: "Strength",

      src:
        "https://cdn.shopify.com/s/files/1/0631/5792/8098/files/strength.png",

      alt:
        "Strength engraved metal tarot card",

      productUrl:
        tarotProductLinks.strength,

      headline:
        "Strength — courage you can hold.",

      support:
        "The classic Strength design recreated as a durable engraved anodized aluminum tarot keepsake."
    },


    {
      key: "wheel",

      name: "Wheel of Fortune",

      src:
        "https://cdn.shopify.com/s/files/1/0631/5792/8098/files/wheel_15c1c8a0-5cd1-41db-aedd-d35747a2c193.png",

      alt:
        "Wheel of Fortune engraved metal tarot card",

      productUrl:
        tarotProductLinks.wheel,

      headline:
        "Wheel of Fortune — change etched permanently in metal.",

      support:
        "Intricate symbolic artwork and fine line detail permanently laser engraved into anodized aluminum."
    },


    {
      key: "sun",

      name: "The Sun",

      src:
        "https://cdn.shopify.com/s/files/1/0631/5792/8098/files/sun.png",

      alt:
        "The Sun engraved metal tarot card",

      productUrl:
        tarotProductLinks.sun,

      headline:
        "The Sun — radiant detail engraved in metal.",

      support:
        "The unmistakable Major Arcana artwork recreated with permanent high-contrast engraving on anodized aluminum."
    },


    {
      key: "chariot",

      name: "The Chariot",

      src:
        "https://cdn.shopify.com/s/files/1/0631/5792/8098/files/chariot.png",

      alt:
        "The Chariot engraved metal tarot card",

      productUrl:
        tarotProductLinks.chariot,

      headline:
        "The Chariot — determination cast in metal.",

      support:
        "Detailed Major Arcana artwork permanently engraved into a durable metal card built for collecting, display or readings."
    }

  ];


  /* =======================================================
     STAGE
     ======================================================= */

  const stage =
    document.getElementById(
      "animatedTarotStage"
    );


  if (!stage) return;


  const slots =
    Array.from(
      stage.querySelectorAll(
        ".tarot-card-slot"
      )
    );


  if (slots.length < 2) return;


  const slotImages =
    slots.map(function (slot) {

      return slot.querySelector(
        ".tarot-card-image"
      );

    });


  let activeSlotIndex = 0;

  let activeCardIndex = 0;

  let changingCard = false;

  let stageVisible = true;

  let cardTimer = null;


  /* =======================================================
     LIGHTBOX CONTEXT
     ======================================================= */

  function applyLightboxContext(
    image,
    card
  ) {

    if (!image || !card) {
      return;
    }


    image.src =
      card.src;


    image.alt =
      card.alt;


    image.setAttribute(
      "data-card-key",
      card.key
    );


    image.setAttribute(
      "data-type",
      "Metal Tarot Card"
    );


    image.setAttribute(
      "data-meta",
      card.name.toUpperCase() +
      " • LASER ENGRAVED ANODIZED ALUMINUM"
    );


    image.setAttribute(
      "data-lightbox-kicker",
      "METAL TAROT CARD"
    );


    image.setAttribute(
      "data-lightbox-headline",
      card.headline
    );


    image.setAttribute(
      "data-lightbox-support",
      card.support
    );


    /*
      PRIMARY CTA:
      exact single-card product.
    */

    image.setAttribute(
      "data-primary-cta-text",
      "SHOP " +
      card.name.toUpperCase() +
      " →"
    );


    image.setAttribute(
      "data-primary-cta-url",
      card.productUrl
    );


    /*
      SECONDARY CTA:
      complete 78-card deck.

      Your lightbox context engine reads these
      as the collection/browse-similar link.
    */

    image.setAttribute(
      "data-collection-title",
      "Shop the Complete 78-Card Metal Tarot Deck"
    );


    image.setAttribute(
      "data-collection-url",
      completeDeckUrl
    );


    image.setAttribute(
      "aria-label",
      "View " +
      card.name +
      " metal tarot card"
    );

  }


  /* =======================================================
     INITIALIZE BOTH LIGHTBOX SLOTS

     Each uses a UNIQUE standalone group.

     That means opening the hero card does NOT show
     unwanted lightbox arrows between the two animation
     slots.
     ======================================================= */

  if (slotImages[0]) {

    slotImages[0].setAttribute(
      "data-lightbox-group",
      "standalone-tarot-hero-a"
    );


    applyLightboxContext(
      slotImages[0],
      tarotCards[0]
    );

  }


  if (slotImages[1]) {

    slotImages[1].setAttribute(
      "data-lightbox-group",
      "standalone-tarot-hero-b"
    );


    applyLightboxContext(
      slotImages[1],
      tarotCards[1]
    );

  }


  /* =======================================================
     PRELOAD ALL ANIMATED CARDS
     ======================================================= */

  tarotCards.forEach(
    function (card) {

      const img =
        new Image();


      img.src =
        card.src;

    }
  );


  /* =======================================================
     CARD CHANGE
     ======================================================= */

  function changeCard() {

    if (
      changingCard ||
      !stageVisible ||
      tarotCards.length < 2
    ) {
      return;
    }


    changingCard =
      true;


    const oldSlot =
      slots[
        activeSlotIndex
      ];


    const newSlotIndex =
      activeSlotIndex === 0
        ? 1
        : 0;


    const newSlot =
      slots[
        newSlotIndex
      ];


    activeCardIndex =
      (
        activeCardIndex + 1
      )
      % tarotCards.length;


    const nextCard =
      tarotCards[
        activeCardIndex
      ];


    const nextImage =
      newSlot.querySelector(
        ".tarot-card-image"
      );


    /*
      Update image + all lightbox product context
      BEFORE the card fades into view.
    */

    applyLightboxContext(
      nextImage,
      nextCard
    );


    newSlot.classList.remove(
      "is-active",
      "is-leaving"
    );


    void newSlot.offsetWidth;


    /*
      Existing card retreats into smoke.
    */

    oldSlot.classList.remove(
      "is-active"
    );


    oldSlot.classList.add(
      "is-leaving"
    );


    /*
      New card materializes.
    */

    window.setTimeout(
      function () {

        newSlot.classList.add(
          "is-active"
        );

      },
      350
    );


    /*
      Cleanup.
    */

    window.setTimeout(
      function () {

        oldSlot.classList.remove(
          "is-leaving"
        );


        activeSlotIndex =
          newSlotIndex;


        changingCard =
          false;

      },
      1650
    );

  }


  /* =======================================================
     TIMER
     ======================================================= */

  function startCardTimer() {

    if (cardTimer) {
      return;
    }


    cardTimer =
      window.setInterval(
        changeCard,
        5200
      );

  }


  function stopCardTimer() {

    if (!cardTimer) {
      return;
    }


    window.clearInterval(
      cardTimer
    );


    cardTimer =
      null;

  }


  startCardTimer();


  /* =======================================================
     3D POINTER PARALLAX
     ======================================================= */

  function handlePointerMove(
    event
  ) {

    const rect =
      stage.getBoundingClientRect();


    const normalizedX =
      (
        event.clientX -
        rect.left
      )
      / rect.width;


    const normalizedY =
      (
        event.clientY -
        rect.top
      )
      / rect.height;


    const rotateY =
      (
        normalizedX -
        .5
      )
      * 7;


    const rotateX =
      (
        normalizedY -
        .5
      )
      * -5;


    stage.style.setProperty(
      "--tarot-rotate-y",
      rotateY.toFixed(2) +
      "deg"
    );


    stage.style.setProperty(
      "--tarot-rotate-x",
      rotateX.toFixed(2) +
      "deg"
    );

  }


  function resetTilt() {

    stage.style.setProperty(
      "--tarot-rotate-y",
      "0deg"
    );


    stage.style.setProperty(
      "--tarot-rotate-x",
      "0deg"
    );

  }


  if (
    window.matchMedia(
      "(hover: hover) and (pointer: fine)"
    ).matches
  ) {

    stage.addEventListener(
      "pointermove",
      handlePointerMove
    );


    stage.addEventListener(
      "pointerleave",
      resetTilt
    );

  }


  /* =======================================================
     OFFSCREEN PERFORMANCE
     ======================================================= */

  if (
    "IntersectionObserver"
    in window
  ) {

    const observer =
      new IntersectionObserver(

        function (entries) {

          entries.forEach(
            function (entry) {

              stageVisible =
                entry.isIntersecting;


              if (
                entry.isIntersecting
              ) {

                stage.classList.remove(
                  "is-paused"
                );


                startCardTimer();

              }

              else {

                stage.classList.add(
                  "is-paused"
                );


                stopCardTimer();

              }

            }
          );

        },

        {
          threshold: .08
        }

      );


    observer.observe(
      stage
    );

  }

})();